import React, { useEffect, useRef, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import "../css/table.min.css";

const CustomTable = ({
  noWrap,
  handelSearchData,
  columns,
  data,
  enableSorting = false,
  enableFilterMatchHighlighting = true,
  enableGlobalFilter,
  enableTopToolbar,
  enableColumnActions = false,
  enableDensityToggle = false,
  enableColumnFilters = false,
  enableFullScreenToggle = false,
  enableHiding = false,
  positionGlobalFilter = "left",
  enablePagination = true,
  enableBottomToolbar = true,
  columnVisibility,
  setColumnVisibility,
  loading,
  totalCount,
  pagination,
  setPagination,
  sorting,
  setSorting,
  muiPaginationProps,
  ...props
}) => {
  const tableRef = useRef(null);
  // const [page,setPage] = useState({ pageIndex: 0, pageSize: 10 });
  // useEffect(()=> {
  //   debugger
  //   console.log(page);
  // }, [page])

  return (
    <div className={`table-wrapper ${noWrap ? "nowrap" : "wrap"}`}>
      <MaterialReactTable
        ref={tableRef}
        {...props}
        enableStickyHeader
        dense
        autoResetAll={false}
        columns={columns}
        data={data || []}
        enableDensityToggle={enableDensityToggle}
        enableHiding={enableHiding}
        enablePagination={enablePagination}
        enableFullScreenToggle={enableFullScreenToggle}
        enableColumnFilters={enableColumnFilters}
        enableColumnActions={enableColumnActions}
        enableBottomToolbar={enableBottomToolbar}
        enableSorting={enableSorting}
        enableTopToolbar={enableTopToolbar || false}
        enableGlobalFilter={enableGlobalFilter}
        enableFilterMatchHighlighting={enableFilterMatchHighlighting}
        positionGlobalFilter={positionGlobalFilter}
        // manualPagination
        // rowCount={totalCount || 0}
        // state={{
        //   columnVisibility,
        //   pagination: {
        //     pageIndex: currentPage || 0, // 0-based
        //     pageSize: pageSize || 10,
        //   },
        //   showProgressBars: loading,
        // }}
        // onPaginationChange={({ pageIndex, pageSize }) => {
        //   console.log(pageIndex,pageSize,"bbbbb")
        //   setPagination((prev) => ({
        //     ...prev,
        //     page: pageIndex + 1, // 1-based for backend
        //     limit: pageSize,
        //   }));
        // }}

      manualPagination
rowCount={totalCount || 0}
        state={{
          columnVisibility,
          pagination: {
            pageIndex: pagination?.pageIndex || 0,
            pageSize: pagination?.pageSize || 10,
          },
          sorting: sorting || [],
        }}
        onPaginationChange={setPagination}
        onSortingChange={setSorting}
        onColumnVisibilityChange={setColumnVisibility}
        muiSearchTextFieldProps={{
          placeholder: `Search ${data ? data.length : 0} rows`,
          sx: { minWidth: "300px" },
          variant: "outlined",
        }}
        muiPaginationProps={{
          rowsPerPageOptions: muiPaginationProps?.rowsPerPageOptions || [
            5, 10, 20, 50,
          ],
          showFirstButton: muiPaginationProps?.showFirstButton ?? true,
          showLastButton: muiPaginationProps?.showLastButton ?? true,
          ...muiPaginationProps,
        }}
        initialState={{
          columnVisibility,
          showGlobalFilter: enableGlobalFilter,
          sorting: sorting || [],
          pagination: {
            pageIndex: pagination?.pageIndex || 0,
            pageSize: pagination?.pageSize || 10,
          },
        }}
      />
    </div>
  );
};

export default CustomTable;
